module.exports = __webpack_public_path__ + "img/header_logo.f206a9b0.png";